export default (function () {
  return {
    init() {
      this.revealCTA();
    },

    revealCTA() {
      const cards = document.querySelectorAll('.js-reveal');

      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          e.target.classList.toggle('is-active');
        });
      });
    },
  };
})();
